import ArrowForwardIcon from '@material-design-icons/svg/filled/arrow_forward.svg?react';
import { useLocation, useNavigate } from 'react-router';
import { usePublisher } from '../hooks/usePublisher';
import { getPublisherVerificationGate } from '../utils/publisherVerification';
import { useSidebarData } from './sidebar/hooks/useSidebarData';

const BANNER_MESSAGE =
  'Identity verification is required before you can submit new releases.';
const CTA_LABEL = 'Complete verification now';

const VERIFICATION_ROUTES: readonly string[] = [
  '/dashboard/submit-kyc',
  '/dashboard/submit-kyb',
  // The Publisher settings page carries its own verification call to action.
  '/dashboard/settings/publisher',
];

export function PublisherVerificationBanner() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activePublisher } = usePublisher();
  const {
    data: { publisherUserJoinId: sidebarPublisherUserJoinId, kybStatusData },
  } = useSidebarData();

  if (!activePublisher) {
    return null;
  }

  const isSidebarDataCurrent =
    sidebarPublisherUserJoinId === activePublisher.publisherUserJoinId;
  const status =
    (isSidebarDataCurrent ? kybStatusData?.status : undefined) ??
    activePublisher.kybStatus;
  const { isApproved } = getPublisherVerificationGate({
    status,
    publisherType: activePublisher.publisherType,
    kycKybBypassEnabled: activePublisher.kycKybBypassEnabled,
  });

  if (isApproved || VERIFICATION_ROUTES.includes(pathname)) {
    return null;
  }

  const verificationRoute =
    activePublisher.publisherType === 'Individual'
      ? '/dashboard/submit-kyc'
      : '/dashboard/submit-kyb';

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-center gap-x-2 gap-y-1 bg-[#F48A39] px-4 py-3 text-center text-sm font-medium text-[#1F140C]">
      <span>{BANNER_MESSAGE}</span>
      <button
        type="button"
        onClick={() => navigate(verificationRoute)}
        className="inline-flex items-center gap-1 rounded-sm font-semibold underline underline-offset-2 transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1F140C]/50"
      >
        {CTA_LABEL}
        <ArrowForwardIcon className="size-4 fill-current" aria-hidden />
      </button>
    </div>
  );
}
